import React from 'react';

const SubscriptionSuccessGrid = ({ subscriptionResponse }) => {
  if (!subscriptionResponse || subscriptionResponse.status !== 'SUCCESS') {
    return <h3 style={{ color: 'red' }}>Error: Unable to fetch subscription data.</h3>
  }

  return (
    <div>
      <h3 style={{ color: 'green' }}>Subscription Response: {subscriptionResponse.action}</h3>
      <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Subscription Type</th>
            <th>Subscription Value</th>
            <th>Status</th>
            <th>Status Message</th>
          </tr>
        </thead>
        <tbody>
          {subscriptionResponse.subscriptionList.map((subscription, index) => (
            <tr key={index}>
              <td>{subscription.subscriptionType}</td>
              <td>{subscription.subscriptionValue}</td>
              <td>{subscription.status}</td>
              <td>{subscription.statusMessage}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubscriptionSuccessGrid;
